isPaymentProcessing